if (!customElements.get('blog-posts-selected')) {
  class BlogPostsSelected extends HTMLElement {
    constructor() {
      super();
      this.initialized = false;
      this.splides = [];
    }

    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.init();
    }

    init() {
      if (typeof window.Splide !== 'undefined') {
        this.mountSliders();
        return;
      }

      const checkInterval = window.setInterval(() => {
        if (typeof window.Splide !== 'undefined') {
          window.clearInterval(checkInterval);
          this.mountSliders();
        }
      }, 100);

      window.setTimeout(() => {
        window.clearInterval(checkInterval);
      }, 10000);
    }

    mountSliders() {
      const sliders = this.querySelectorAll('[data-blog-posts-selected-mobile-slider]');

      sliders.forEach((slider) => {
        if (slider.dataset.sliderMounted === 'true') return;

        const totalSlides = slider.querySelectorAll('.splide__slide').length;
        if (!totalSlides) return;

        slider.dataset.sliderMounted = 'true';

        const mobileRightPadding = totalSlides > 1 ? '6%' : '0px';

        const splide = new Splide(slider, {
          type: 'slide',
          arrows: false,
          pagination: totalSlides > 1,
          drag: totalSlides > 1,
          rewind: false,
          speed: 500,
          easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
          gap: '16px',
          perMove: 1,
          flickMaxPages: 1,
          updateOnMove: true,
          perPage: 1,
          padding: {
            left: '0px',
            right: mobileRightPadding,
          },
          classes: {
            pagination: 'splide__pagination blog-posts-selected__pagination',
            page: 'splide__pagination__page blog-posts-selected__pagination-dot',
          },
        });

        if (totalSlides > 1) {
          splide.on('pagination:mounted', (data) => {
            data.items.forEach((item, index) => {
              item.button.innerHTML = `
                <span class="blog-posts-selected__pagination-icon" aria-hidden="true">
                  <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11.5 0L15.5 7.5L23 11.5L15.5 15.5L11.5 23L7.5 15.5L0 11.5L7.5 7.5L11.5 0Z" fill="currentColor"/>
                  </svg>
                </span>
              `;
              item.button.setAttribute('aria-label', `Go to slide ${index + 1}`);
            });
          });
        }

        splide.mount();
        this.splides.push(splide);
      });
    }
  }

  customElements.define('blog-posts-selected', BlogPostsSelected);
}
